module.exports = __webpack_public_path__ + "fonts/AvenyTWEB.0adc23ca.woff2";